import React from 'react';
import { DataTable, TableBody } from '@/components/ui/data-table';
import type { DataTableColumn } from '@/components/ui/data-table/DataTableContext';
import { Product } from '@/data/productData';
import ProductTableRow from './ProductTableRow';

interface ProductTableProps {
  products: Product[];
  includeSample?: boolean;
  onArchive?: () => void;
}

const ProductTable: React.FC<ProductTableProps> = ({ products, includeSample = false, onArchive }) => {
  const columns: DataTableColumn[] = [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'price', label: 'Price', align: 'left' },
    { id: 'type', label: 'Period', align: 'left' },
    { id: 'created', label: 'Created', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'actions', label: ' Actions', align: 'right' },
  ];

  return (
      <DataTable className="rounded-lg border shadow-sm overflow-hidden">
      <DataTable.Header columns={columns} />
      <TableBody>
        {products.length === 0 ? (
          <DataTable.Empty colSpan={6} message="No products found matching your filters" />
        ) : (
          products.map((product) => (
            <ProductTableRow 
              key={product.id} 
              product={product} 
              onArchive={onArchive}
            />
          ))
        )}
      </TableBody>
    </DataTable>
  );
};

export default ProductTable;